import React from 'react'
import { Link } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import logo from '../images/logo-dark.svg';
import logo2 from '../images/logo-white.svg';

export default class Header extends React.Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this);
    this.state = { isShow: true }
  }
  handleClick() {
    this.setState(prevState => ({
      isShow: !prevState.isShow
    }));
  }
  render() {
    return (
      <header className="clearfix white">
        <div className="container desktopMenu">
          <div className="left">
            <Link to="/" className="logo">
              <img src={logo2} title="STech" alt="STech" id="home" />
              <img src={logo} title="STech" alt="STech" id="sub" />
            </Link>
          </div>
          <div className="right">
            <nav>
              <ul>
                <li>
                  <NavLink exact to="/about">
                    About Us
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/partners">Our Partners</NavLink>
                </li>
                <li>
                  <NavLink to="/products">Products</NavLink>
                </li>
                <li>
                  <NavLink to="/news">News</NavLink>
                </li>
                <li>
                  <NavLink to="/careers">Careers</NavLink>
                </li>
                <li>
                  <NavLink to="/affiliate">Affiliate</NavLink>
                </li>
                <NavLink to="/contact" className="btn">
                  <span>Get in Touch</span>
                </NavLink>
              </ul>
            </nav>
          </div>
        </div>
        <div className="mobileMenu">
          <div className="logo">
            <Link to="/" className="logo">
              <img
                src={logo2}
                title="STech"
                alt="STech"
                id="home"
                style={{
                  display: this.state.isShow === false ? "block" : "none"
                }}
              />
              <img
                src={logo}
                title="STech"
                alt="STech"
                id="sub"
                style={{
                  display: this.state.isShow === false ? "none" : "block"
                }}
              />
            </Link>
          </div>
          <div
            onClick={this.handleClick}
            className={this.state.isShow ? "hamburger" : "hamburger active"}
          >
            <div className="bar1" />
            <div className="bar2" />
            <div className="bar3" />
          </div>
          <div className={this.state.isShow ? "menu" : "menu active"}>
            <ul>
              <li>
                <NavLink exact to="/about" onClick={this.handleClick}>
                  About Us
                </NavLink>
              </li>
              <li>
                <NavLink to="/partners" onClick={this.handleClick}>
                  Our Partners
                </NavLink>
              </li>
              <li>
                <NavLink to="/products" onClick={this.handleClick}>
                  Products
                </NavLink>
              </li>
              <li>
                <NavLink to="/news" onClick={this.handleClick}>
                  News
                </NavLink>
              </li>
              <li>
                <NavLink to="/careers" onClick={this.handleClick}>
                  Careers
                </NavLink>
              </li>
              <li>
                <NavLink to="/affiliate" onClick={this.handleClick}>
                  Affiliate
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact" onClick={this.handleClick}>
                  Get in Touch
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </header>
    );
  }
}
